import { render, staticRenderFns } from "./ResourceCards.vue?vue&type=template&id=6a3d7a26"
import script from "./ResourceCards.vue?vue&type=script&lang=ts"
export * from "./ResourceCards.vue?vue&type=script&lang=ts"
import style0 from "./ResourceCards.vue?vue&type=style&index=0&id=6a3d7a26&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3d7a26')) {
      api.createRecord('6a3d7a26', component.options)
    } else {
      api.reload('6a3d7a26', component.options)
    }
    module.hot.accept("./ResourceCards.vue?vue&type=template&id=6a3d7a26", function () {
      api.rerender('6a3d7a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/ResourceCards.vue"
export default component.exports